import { BehaviorSubject } from 'rxjs';

import { SystemErrors } from '../system-types';

export const _systemErrorInitialValue: {
  type: SystemErrors;
  data: {
    description?: string; // Optional description shown on full page errors
    error?: any; // Not used right now but may be useful for logging error and debugging.
  };
} = {
  type: SystemErrors.NONE,
  data: {},
};

const subject = new BehaviorSubject(_systemErrorInitialValue);

/**
 * Publishes an invalid short term token error by emitting a new event
 */
const publishInvalidShortTermToken = (): void => {
  subject.next({ type: SystemErrors.INVALID_SHORT_TERM_TOKEN, data: {} });
};

/**
 * Publishes an invalid short term token error by emitting a new event
 */
const publishCriticalError = (data: { description?: string; error?: any } = {}): void => {
  subject.next({
    type: SystemErrors.CRITICAL_ERROR,
    data: { ...data },
  });
};

/**
 * @returns the value of the token regardless of whether it's valid or not
 */
const getSystemError = () => {
  return subject.value;
};

export const systemError = {
  publishInvalidShortTermToken,
  publishCriticalError,
  getSystemError,
  subject,
};
